<script>
// @ts-check
import { mapState, mapMutations } from 'vuex'
import * as R from 'ramda'
import ProgressNav from './progress-nav'
import ProgressRow from './progress-row'
import { Maybe, Wizard } from '@domain' // eslint-disable-line
import {
  computeWizardProgress,
  computeWizardStepsNeeded,
} from '@utils/wizardProgress'

export default {
  components: { ProgressNav, ProgressRow },
  data: function() {
    return {}
  },
  computed: {
    ...mapState('wizard', {
      chartType: state => {
        return state.chartType[0] ? state.chartType[0].displayText() : ''
      },
      stepsNeeded: computeWizardStepsNeeded,
      progresses: computeWizardProgress,
    }),
    currentProgresses() {
      let index = R.findIndex(R.propEq('to', this.$route.path), this.progresses)
      return index === -1 ? this.progresses : R.slice(0, index, this.progresses)
    },
  },
  created() {
    if (this.$route.fullPath === '/dataViz/wizard/breakdown') {
      this.SetChartSelection(Maybe.Nothing)
    }
  },
  methods: {
    ...mapMutations('wizard', {
      SetChartSelection: 'SetChartSelection',
    }),
  },
}
</script>

<template>
  <v-layout justify-center>
    <v-flex xs8>
      <v-layout column>
        <v-flex>
          <ProgressNav
            :progress-value="currentProgresses.length"
            :progress-max-value="stepsNeeded === 0 ? 2: stepsNeeded"
            :report="chartType"
          />
        </v-flex>
        <v-divider/>
        <v-flex
          v-for="p in currentProgresses"
          :key="p.title"
          class="mt-2 mb-2">
          <ProgressRow
            :content="p.content"
            :title="p.title"
            :btn-to="p.to"/>
          <v-divider/>
        </v-flex>
      </v-layout>
      <router-view/>
    </v-flex>
  </v-layout>
</template>
